import { useQuery } from "@tanstack/react-query";
import { createContext, useContext, type ReactNode } from "react";
import { api } from "./api";
import type { BootstrapData, CapacityRequest } from "./types";

export const bootstrapQueryKey = ["bootstrap"] as const;

export function useBootstrapQuery() {
  return useQuery({
    queryKey: bootstrapQueryKey,
    queryFn: () => api<BootstrapData>("/api/bootstrap")
  });
}

const BootstrapContext = createContext<BootstrapData | null>(null);

export function BootstrapProvider({ value, children }: { value: BootstrapData; children: ReactNode }) {
  return <BootstrapContext.Provider value={value}>{children}</BootstrapContext.Provider>;
}

export function useBootstrap() {
  const value = useContext(BootstrapContext);
  if (!value) throw new Error("Bootstrap context is not available.");
  return value;
}

export function hasRole(roles: string, ...required: string[]) {
  const roleSet = new Set(roles.split(",").map((item) => item.trim()));
  return required.some((role) => roleSet.has(role));
}

export function isApproverForRequest(data: BootstrapData, request: CapacityRequest) {
  if (hasRole(data.user.roles, "admin", "superadmin")) return true;
  const machineIds = new Set(request.steps.map((step) => step.machineId));
  return data.machines.some((machine) =>
    machineIds.has(machine.id) &&
    (machine.ownerUserId === data.user.id || machine.substituteOwnerUserId === data.user.id)
  );
}
